import { BusProvider, SelectionProvider } from 'context';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { IntlProvider } from "react-intl";
import Documents from "pages/Documents";
import Uploader from "pages/Uploader";
import FilestorePreview from "pages/FilestorePreview";
import messages_en from "./lang/en.json"
import ThemeUpdater from 'theme/ThemeUpdater';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import { PropsWithChildren } from 'react';
import { Alert } from '@mui/material';
import { applicationSlot } from './utils/applicationSlot';
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider, } from "@mui/x-date-pickers";

const client = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            retry: false,
        },
    }
});
const themes = {
    dark: `${import.meta.env.BASE_URL}dark-theme.css`,
    light: `${import.meta.env.BASE_URL}light-theme.css`,
};

function App() {
    return (<>
        {applicationSlot() === "blue"
            && <Alert severity="warning">WARNING: BLUE SLOT - VERSION: {process.env.PUBLIC_URL || "localhost"}</Alert>}
        <Router />
    </>
    );
}

function Router() {

    return (
        <BrowserRouter basename={"/"}>
            <Routes>
                <Route path={`/solution/:solutionId/workspace/:workspaceId/:viewId`} element={
                    <Contexts>
                        <Documents />
                    </Contexts>
                } />
                <Route path={`/solution/:solutionId/workspace/:workspaceId/:viewId/upload`} element={
                    <Contexts>
                        <Uploader />
                    </Contexts>
                } />
                <Route path={`/solution/:solutionId/workspace/:workspaceId/preview/:fileId`} element={
                    <FilestoreContexts>
                        <FilestorePreview />
                    </FilestoreContexts>
                } />
                <Route path="*" element={<NotFound />} />
            </Routes>
        </BrowserRouter>
    );
}

function FilestoreContexts({ children }: PropsWithChildren<{}>) {
    return (
        <ThemeSwitcherProvider themeMap={themes} defaultTheme="light">
            <ThemeUpdater>
                <IntlProvider locale='en' messages={messages_en}>
                    <QueryClientProvider client={client}>
                        {children}
                    </QueryClientProvider>
                </IntlProvider>
            </ThemeUpdater>
        </ThemeSwitcherProvider>
    );
}

function Contexts({ children }: { children: JSX.Element }) {

    return (
        <ThemeSwitcherProvider themeMap={themes} defaultTheme="light">
            <ThemeUpdater>
                <IntlProvider locale='en' messages={messages_en}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <QueryClientProvider client={client}>
                            <BusProvider>
                                <SelectionProvider>
                                    {children}
                                </SelectionProvider>
                            </BusProvider>
                        </QueryClientProvider>
                    </LocalizationProvider>
                </IntlProvider>
            </ThemeUpdater>
        </ThemeSwitcherProvider>
    )
}

export default App;

export function NotFound() {
    return <Alert severity='warning' sx={{ m: 1 }}>
        This page doesn't exist
    </Alert>
}